import { Layout, Chat } from '../components';

const ChatPage = () => {
  return (
    <Layout>
      <Chat />
    </Layout>
  );
};

export default ChatPage;
